import * as React from 'react';

// REDUX
import { useAppSelector } from '../../../store';

// PACKAGES
import { ErrorMessage, connect, FastField, Field } from 'formik';

// COMPONENTS
import SingleSelect from '../../../components/SingleSelect';
import TeacherRegistrationForm from './TeacherRegistrationForm';
import WorkingWithChildrenForm from './WorkingWithChildrenForm';

// TYPES
import { DomainCertificationType } from '../../../api/models';

interface ChooseCertificationTypes {
	formik?: any;
	index: number;
	hasExisting?: boolean;
}

export const ChooseCertification: React.FC<ChooseCertificationTypes> = ({ formik, index, hasExisting }) => {
	let certificationTypesLists = useAppSelector((state) => state?.lists.authorityOfWorkCertifications);

	if (hasExisting && formik.values.hasValidExisitingCertificate && index === 0) {
		certificationTypesLists = certificationTypesLists?.concat([
			{ value: 'useExisting' as DomainCertificationType, label: 'Use Existing' }
		]);
	}

	const switchForm = (role: string, index: number) => {
		switch (role) {
			case 'TeacherRegistration':
				return <FastField children={() => <TeacherRegistrationForm index={index} />} />;

			case 'WorkingWithChildrenCheck':
				return <FastField children={() => <WorkingWithChildrenForm index={index} />} />;

			default:
				break;
		}
	};

	return (
		<>
			<section>
				<Field
					name={`accountCertification[${index}].certificationType`}
					children={() => {
						return (
							<>
								<SingleSelect
									options={certificationTypesLists}
									placeholder="Select form of credentials..."
									name={`accountCertification[${index}].certificationType`}
									value={formik.values.accountCertification[index].certificationType}
									onChange={(val: string) => {
										formik.setFieldValue(`accountCertification[${index}].certificationType`, val);
										formik.setFieldValue('useExistingCertifications', false);
									}}
								/>
							</>
						);
					}}
				/>

				<ErrorMessage name={`accountCertification[${index}].certificationType`}>
					{(error) => <div className="form-validation-error">{error}</div>}
				</ErrorMessage>

				{!formik.values.addLater
					? switchForm(formik.values.accountCertification[index].certificationType, index)
					: null}
			</section>
		</>
	);
};

export default connect(ChooseCertification);
